import React from 'react';
import { Box, Grid, Container, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import useStyles from './CreditTypeDetails.styled';
import { useParams } from 'react-router-dom';
import { CreditTypeDetailsWidget } from 'components/CreditTypes';
import Logs from 'components/Logs';
import Comments from 'components/Comments';

const CreditTypeDetails = () => {
  const classes = useStyles();
  const { id } = useParams();

  return (
    <Layout title={i18n.t('credit_types.title')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
                    {i18n.t('credit_types.details_title', { id: id || '--' })}
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CreditTypeDetailsWidget id={id} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Comments type="invoice_item_type" id={+id} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Logs
                      title={i18n.t('credit_types.logs')}
                      targetType={'InvoiceItemType'}
                      targetId={+id}
                      height={400}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export { CreditTypeDetails };
